export function getAge(birthDate = '', originDate = '') {
  if (!birthDate) {
    return 0
  }
  const today = originDate ? new Date(originDate) : new Date()
  const birth = new Date(birthDate)

  const yearDiff = today.getFullYear() - birth.getFullYear()
  const monthDiff = today.getMonth() - birth.getMonth()
  const dayDiff = today.getDate() - birth.getDate()

  const birthDayIsBeforeNow = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)

  return birthDayIsBeforeNow ? yearDiff - 1 : yearDiff
}
